import React, {Component} from "react";
import {connect} from "react-redux";
import {BackTop, Button, Empty, Icon, Input, Skeleton, Table, Typography} from "antd";
import {processDataForDownload} from "../../appRedux/actions";

import {InfoModel} from './leaseInfo'
import Status from "./status";
import Cost from "./cost";
import Revenue from './revenue';
import IdealDays from './idealDays';
import Vendor from "./contractVendor";

const {Text} = Typography;

class LeasingReport extends Component {
  state = {
    resource: null,
    showResource: true,
    showDescription: false,
    leasableInfo: null,
    currentAsset: '',
    currentAssetCode: '',
    assetData: [],
    updatedLeasableInfo: [],
    searchText: '',
    searchedColumn: '',
    status: [],
    downloadData: [],
    dynamicData: {},
    jayData: [],
    allStatus: [],
    allRevenue: [],
    allCost: [],
    allIdealDays: [],
  };

  componentDidMount = () => {
    this.fetchData();
  }

  setDynamicData = (assetId, field, value) => {
    const data = this.state.dynamicData;
    const assetData = data[assetId] || {};
    assetData[field] = value;
    data[assetId] = assetData;
    this.setState({
      dynamicData: data,
    })
    // {
    //   assetId : {
    //     filed: value
    //     filed: value
    //   },
    //   assetId : {
    //     filed: value
    //     filed: value
    //   }
    // }

  };


  componentWillReceiveProps(nextProps, nextContext) {
    // console.log('I mmmm')
    if (nextProps && nextProps.status) {
      const {id, status} = nextProps.status;
      this.setDynamicData(id, 'status', status && status.status || 'OPEN')
    }

    if (nextProps && nextProps.updatedLeaseInfo != this.props.updatedLeaseInfo) {
      const data = [...this.state.assetData];
      this.setState({
        assetData: data.map(item => {
          if (item._id.toString() === this.state.currentAsset.toString()) {
            const {description, initialLeaseStartDate} = nextProps.updatedLeaseInfo;
            const {images} = item.leasableInfo;
            item.leasableInfo = {description, initialLeaseStartDate, images};
          }
          return item;
        })
      });
    } else if (nextProps && nextProps.uploadedPhoto != this.props.uploadedPhoto) {
      // console.log(nextProps.uploadedPhoto, this.props.uploadedPhoto)
      const data = [...this.state.assetData];
      this.setState({
        assetData: data.map(item => {
          if (item._id.toString() === this.state.currentAsset.toString()) {
            //const {images} = nextProps.uploadedPhoto;
            const {description, initialLeaseStartDate, images} = item.leasableInfo;
            const newImages = [...images, nextProps.uploadedPhoto]
            item.leasableInfo = {description, initialLeaseStartDate, images: newImages};
          }
          return item;
        })
      });
    } else if (nextProps && nextProps.isPhotoRemoved != this.props.isPhotoRemoved) {
      const data = [...this.state.assetData];
      this.setState({
        assetData: data.map(item => {
          if (item._id.toString() === this.state.currentAsset.toString()) {
            const {description, initialLeaseStartDate, images} = item.leasableInfo;
            // console.log(images);
            const newImage = images.filter(im => im._id !== nextProps.isPhotoRemoved)
            // console.log(`index - ${newImage}`);
            item.leasableInfo = {description, initialLeaseStartDate, images: newImage};
          }
          return item;
        })
      });
    } else if (this.props.datas.length === 0 && nextProps.datas)
      this.setState({
        assetData: nextProps.datas,
      });
    if (!this.state.downloadData || this.state.downloadData.length === 0) {
      // console.log(nextProps.datas);
      this.setState({
        downloadData: nextProps.datas
      });
    } else if (this.props.datas === nextProps.datas)
      this.setState({
        assetData: nextProps.datas,
      });
    if (!this.state.downloadData || this.state.downloadData.length === 0) {
      // console.log(nextProps.datas);
      this.setState({
        downloadData: nextProps.datas
      });
    }
  }

  fetchData = () => {
    this.props.fetchResources();
  };


  showDescriptionHandler = (leasableInfo, assetId, code) => {
    this.setState({
      showDescription: true,
      leasableInfo: leasableInfo,
      currentAsset: assetId,
      currentAssetCode: code,
    });
  };

  closeDescriptionModal = () => {
    this.setState({
      showDescription: false,
      leasableInfo: null,
      currentAsset: '',
      currentAssetCode: '',
    });
  }

  getStatus = (assetId) => {
    // console.log(this.state.status)
    return <Status id={assetId} addStatusToRecord={this.addStatusToRecord} allStatus={this.state.allStatus}
                   setDynamicData={this.setDynamicData} {...this.props}/>
  }

  getVendor = (assetId) => {
    // console.log(this.state.allStatus && this.state.allStatus[assetId] && this.state.allStatus[assetId]['contract'] && this.state.allStatus[assetId]['contract'][assetId])
    // return <Vendor id={assetId} /*addStatusToRecord={this.addStatusToRecord}*/ allStatus={this.state.allStatus} setDynamicData={this.setDynamicData} {...this.props}/>
    return this.state.allStatus && this.state.allStatus[assetId] && this.state.allStatus[assetId]['contract'] &&
      this.state.allStatus[assetId]['contract'][assetId] && this.state.allStatus[assetId]['contract'][assetId].vendor && this.state.allStatus[assetId]['contract'][assetId].vendor.name || 'NA'
  }

  getIsVendorLinked = (assetId, subLocationVendor) => {
    // console.log(assetId, subLocationVendor);
    try {
      const vendorId = this.state.allStatus && this.state.allStatus[assetId] && this.state.allStatus[assetId]['contract'] &&
        this.state.allStatus[assetId]['contract'][assetId] && this.state.allStatus[assetId]['contract'][assetId].vendor && this.state.allStatus[assetId]['contract'][assetId].vendor._id || ''
      // console.log(vendorId, (subLocationVendor && subLocationVendor.toString() === vendorId) ? 'Yes' : 'No')
      return (subLocationVendor && subLocationVendor.toString() === vendorId.toString()) ? 'Yes' : 'No'
    } catch (e) {
      return 'No'
    }
  }

  getCost = (assetId) => {
    return <Cost id={assetId} addCostToRecord={this.addCostToRecord} allCost={this.state.allCost}
                 setDynamicData={this.setDynamicData} {...this.props}/>
  }

  getRevenue = (assetId) => {
    return <Revenue id={assetId} addRevenueToRecord={this.addRevenueToRecord} allRevenue={this.state.allRevenue}
                    setDynamicData={this.setDynamicData} {...this.props}/>
  }

  getIdealDays = (assetId) => {
    return <IdealDays id={assetId} addIdealDaysToRecord={this.addIdealDaysToRecord}
                      allIdealDays={this.state.allIdealDays} setDynamicData={this.setDynamicData} {...this.props}/>
  }

  addStatusToRecord = (id, status) => {
    const allStatus = this.state.allStatus;
    allStatus[id] = status;
    this.setState({
      allStatus: allStatus
    })
  }

  addRevenueToRecord = (id, revenue) => {
    const allRevenue = this.state.allRevenue;
    allRevenue[id] = revenue;
    this.setState({
      allRevenue: allRevenue
    })
  }

  addCostToRecord = (id, cost) => {
    const allCost = this.state.allCost;
    allCost[id] = cost;
    this.setState({
      allCost: allCost
    })
  }

  addIdealDaysToRecord = (id, idealDays) => {
    const allIdealDays = this.state.allIdealDays;
    allIdealDays[id] = idealDays;
    this.setState({
      allIdealDays: allIdealDays
    })
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
      <div style={{padding: 8}}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{width: 188, marginBottom: 8, display: 'block'}}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{width: 90, marginRight: 8}}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
    ),
    onFilter: (value, record) => {
      // console.log(value, record, dataIndex)
      if (dataIndex === 'status')
        dataIndex = 'currentStatus'
      return record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
    },
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      (<Text ellipsis>{text}</Text>),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({searchText: ''});
  };

  handleTableChange = (pagination, filters, sorter, extra) => {
    // console.log(extra.currentDataSource);
    // console.log(this.state.assetData);
    const currentDataIds = extra.currentDataSource.map(current => current.id);
    // console.log(currentDataIds);
    // const downloadData = this.state.assetData || [].filter(asset => currentDataIds.includes(asset._id));
    this.setState({
      downloadData: this.state.assetData.filter(asset => currentDataIds.includes(asset._id.toString()))
    });

    const pager = {...this.state.pagination};
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    const {status} = filters;
    if (status) {
      this.setState({
        status: status
      })
      // this.props.fetchResources({
      // results: pagination.pageSize,
      // page: pagination.current,
      // sortField: sorter.field,
      // sortOrder: sorter.order,
      // status,
      // })
    }
  };

  getDownloadData = () => {
    const {downloadData} = this.state;
    // console.log('data', downloadData);
    // console.log('St', this.state.dynamicData);

    this.props.processDataForDownload(downloadData)
  };

  render() {
    // console.log(this.props.datas, this.state.assetData)
    let assets = <Skeleton active/>;

    if (this.props.loading === false) {
      if (this.state.assetData && this.state.assetData.length > 0) {
        const cols = [
          {
            title: "Asset Code",
            dataIndex: "assetCode",
            key: "assetCode",
            ...this.getColumnSearchProps('assetCode'),
            width: 120,
            // fixed: 'left',
            sorter: (a, b) => (a.assetCode > b.assetCode) ? -1 : (a.assetCode < b.assetCode) ? 1 : 0,
          },
          {
            title: "Lease Info",
            dataIndex: "info",
            key: "info",
            render: (_, record) => (<Button type="primary" icon="edit" size={'small'}
                                            onClick={() => this.showDescriptionHandler(record.info, record.id, record.assetCode)}/>),
            width: 50,
            // fixed: 'left',
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
            // ...this.getColumnSearchProps('status'),
            // filters: [{text: 'Available', value: 'Available'}, {text: 'Under Lease', value: 'Under Lease'}],
            render: (_, record) => this.getStatus(record.id),
            width: 100,
            // sorter: (a, b) => (a.text > b.text) ? -1 : (a.text < b.text) ? 1 : 0,
          },
          {
            title: "Vendor",
            dataIndex: "vendor",
            key: "vendor",
            // ...this.getColumnSearchProps('status'),
            // filters: [{text: 'Available', value: 'Available'}, {text: 'Under Lease', value: 'Under Lease'}],
            render: (_, record) => this.getVendor(record.id),
            width: 200,
            // sorter: (a, b) => (a.text > b.text) ? -1 : (a.text < b.text) ? 1 : 0,
          },
          {
            title: "Is Linked",
            dataIndex: "isLinked",
            key: "isLinked",
            width: 50,
            render: (_, record) => this.getIsVendorLinked(record.id, record.subLocationVendor),
            // sorter: (a, b) => (a.assetType > b.assetType) ? -1 : (a.assetType < b.assetType) ? 1 : 0,
            // ...this.getColumnSearchProps('assetType'),
          },
          {
            title: "Asset Type",
            dataIndex: "assetType",
            key: "assetType",
            width: 150,
            sorter: (a, b) => (a.assetType > b.assetType) ? -1 : (a.assetType < b.assetType) ? 1 : 0,
            ...this.getColumnSearchProps('assetType'),
          },
          {
            title: "Asset Sub Type",
            dataIndex: "assetSubType",
            key: "assetSubType",
            width: 150,
            sorter: (a, b) => (a.assetSubType > b.assetSubType) ? -1 : (a.assetSubType < b.assetSubType) ? 1 : 0,
            ...this.getColumnSearchProps('assetSubType'),
          },
          {
            title: "Asset Model",
            dataIndex: "assetModel",
            key: "assetModel",
            width: 150,
            sorter: (a, b) => (a.assetModel > b.assetModel) ? -1 : (a.assetModel < b.assetModel) ? 1 : 0,
            ...this.getColumnSearchProps('assetModel'),
          },
          {
            title: "Asset Location",
            dataIndex: "assetLocation",
            key: "assetLocation",
            width: 150,
            sorter: (a, b) => (a.assetLocation > b.assetLocation) ? -1 : (a.assetLocation < b.assetLocation) ? 1 : 0,
            ...this.getColumnSearchProps('assetLocation'),
          },
          {
            title: "Asset Sub Location",
            dataIndex: "assetSubLocation",
            key: "assetSubLocation",
            width: 150,
            sorter: (a, b) => (a.assetSubLocation > b.assetSubLocation) ? -1 : (a.assetSubLocation < b.assetSubLocation) ? 1 : 0,
            ...this.getColumnSearchProps('assetSubLocation'),
          },
          {
            title: "Ownership Cost",
            dataIndex: "totalOwnershipCost",
            key: "totalOwnershipCost",
            render: (_, record) => this.getCost(record.id),
            width: 150,
          },
          {
            title: "Revenue Till Date",
            dataIndex: "revenueTillDate",
            key: "revenueTillDate",
            render: (_, record) => this.getRevenue(record.id),
            width: 150,
          },
          {
            title: "Ideal Days",
            dataIndex: "idealDays",
            key: "idealDays",
            render: (_, record) => this.getIdealDays(record.id),
            width: 100,
            // fixed: 'right',
          },
        ];
        // console.log(this.state.assetData);
        const assetDatas = (this.state.assetData || [])
          .map((data, index) => {
              let info = {};
              if (data.leasableInfo) {
                const {description, initialLeaseStartDate, images} = data.leasableInfo;
                info = {
                  description, initialLeaseStartDate, images: images.map(image => {
                    if (image.uid)
                      return image;
                    else if (image.file) {
                      return {
                        uid: image._id,
                        name: image.name,
                        status: 'done',
                        url: image.file.path,
                      }
                    }
                  })
                }
              }

              // console.log(data.client);

              return {
                key: index,
                id: data._id,
                assetCode: data.assetCode,
                vendor: 'NA',
                assetType: data.assetType && data.assetType.name ? data.assetType.name : '',
                assetSubType: data.subType && data.subType.name ? data.subType.name : '',
                assetModel: data.model && data.model.name ? data.model.name : '',
                assetLocation: data.location && data.location.name ? data.location.name : '',
                assetSubLocation: data.client && data.client.name ? data.client.name : '',
                subLocationVendor: data.client && data.client.vendor || null,
                totalOwnershipCost: 0,
                revenueTillDate: 0,
                idealDays: 0,
                info: info, //data.leasableInfo, // ? data.leasableInfo.description ? data.leasableInfo.description : '' : '',
                //photos: data.leasableInfo ? data.leasableInfo.images ? data.leasableInfo.images : [] : [],
                currentStatus: 'NA',
              };
            }
          );

        assets =
          assetDatas && assetDatas.length > 0 ? (
            <>
              <Table
                onChange={this.handleTableChange}
                dataSource={assetDatas}
                // pagination={false}
                pagination={{pageSize: 10}}
                columns={cols}
                loading={this.props.loading}
                scroll={{x: true}}
                // scroll={{ y: 250 }}
                // rowKey={(record) =>
                //   record.type +
                //   record.location._id +
                //   (record.client && record.client._id)
                // }
              />
              <Button type='danger' onClick={() => this.getDownloadData()}
                      icon='edit'>Export</Button>
            </>
          ) : null;
      } else assets = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>;
    }

    return (
      <div>
        <BackTop/>
        {/*<Spin tip="Processing..." spinning={this.props.loading}>*/}
        {assets}
        {/*{(!this.props.downloading && this.props.downloadData.length > 0) ?*/}
        {/*<CSVDownload data={this.props.downloadData} filename="leasing-report.csv"/>*/}
        {/*: null*/}
        {/*}*/}
        {/*</Spin>*/}
        {
          this.state.showDescription ?
            <InfoModel isVisible={this.state.showDescription}
                       loading={this.props.loading}
                       closeDescription={this.closeDescriptionModal}
                       info={this.state.leasableInfo}
                       code={this.state.currentAssetCode}
              //updatedLeaseInfo={this.props.updatedLeaseInfo}
                       removeLeasePhoto={(doc) => this.props.removePhoto(this.state.currentAsset, doc)}
                       uploadLeasePhoto={(file) => this.props.uploadPhoto(this.state.currentAsset, file)}
                       updateDescription={(desc, date) => this.props.updateLeasingInfo(this.state.currentAsset, desc, date)} {...this.props}/> : null

        }
      </div>
    );
  }
}

const mapStateToProps = ({auth, poReport, commonData, leasing}) => {
  return {
    status: leasing.leasingStatus,
    downloading: leasing.downloadStart,
    downloadData: leasing.downloadData,
    // authUser: auth.authUser,
    // total: poReport.total,
    // datas: poReport.datas,
    // resource: poReport.resource,
    // loading: commonData.loading,
    // pageNo: poReport.pageNo,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    processDataForDownload,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(LeasingReport);
